import { useEffect } from 'react';
import { useIsMobile } from './use-mobile';

/**
 * Hook optimisé pour les interactions mobiles
 * Utilise uniquement CSS pour éviter les forced reflows
 */
export const useInteractionOptimization = () => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    // Injecter uniquement les styles CSS optimisés (pas de manipulation DOM)
    const style = document.createElement('style');
    style.id = 'touch-optimization-styles';
    style.textContent = `
      * {
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
      }
      
      button, a, [role="button"] {
        -webkit-tap-highlight-color: rgba(0,0,0,0.1);
        touch-action: manipulation;
        transition: transform 0.1s ease;
      }
      
      /* Utiliser :active au lieu de touchstart/touchend JavaScript */
      button:active, a:active, [role="button"]:active {
        transform: scale(0.98);
      }
      
      input, textarea, select {
        touch-action: manipulation;
      }
    `;
    
    // Vérifier si les styles existent déjà
    if (!document.head.querySelector('#touch-optimization-styles')) {
      document.head.appendChild(style);
    }

    return () => {
      // Nettoyage
      const existingStyle = document.head.querySelector('#touch-optimization-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [isMobile]);

  return { isMobile };
};
